import { render, staticRenderFns } from "./SalaryDetail.vue?vue&type=template&id=afd4f502&scoped=true"
import script from "./SalaryDetail.vue?vue&type=script&lang=js"
export * from "./SalaryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4f502",
  null
  
)

export default component.exports